import React, { useContext } from 'react';
import { AuthContext } from '../../../context/auth';
import Footer from '../../../components/Footer';
import MenuPrincipalLicores from '../../../components/hacienda/impuestoLicores/menuPrincipalLicores';

function ImpuestoLicores() {

  // let op = require('../../../../src/modulos/datos');
  const { user } = useContext(AuthContext);
  // let per = JSON.parse(localStorage.getItem('permisos'));

  return user && (
      <div style={{ height: "100dvh", padding: 0 }}>
           <MenuPrincipalLicores/>
           <Footer />
      </div>
    )
}


export default ImpuestoLicores;
